import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WINNER_FEATURE_KEY, WinnerState } from './winner.reducer';

// Lookup the 'Winner' feature state managed by NgRx
export const getWinnerState =
  createFeatureSelector<WinnerState>(WINNER_FEATURE_KEY);

export const getWinnerLoaded = createSelector(
  getWinnerState,
  (state: WinnerState) => state.loaded,
);
export const getWinnerLoading = createSelector(
  getWinnerState,
  (state: WinnerState) => state.loading,
);

export const getData = createSelector(
  getWinnerState,
  (state: WinnerState) => state.data,
);

export const getParams = createSelector(
  getWinnerState,
  (state: WinnerState) => state.params,
);

export const getWinnerError = createSelector(
  getWinnerState,
  (state: WinnerState) => state.error,
);

export const getWinnerProcessing = createSelector(
  getWinnerState,
  (state: WinnerState) => state.processing,
);
